import { createApp } from 'vue';
import App from './App.vue';

const supabaseUrl = 'https://bjuvsqhnrvogosdypepx.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqdXZzcWhucnZvZ29zZHlwZXB4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkyODIwOTAsImV4cCI6MjA2NDg1ODA5MH0.lWtG2AB_XysWvyJQLsDdDJEXr6eOjHhsKhvB465UExU';

(function initGlobalTooltip() {
    const tooltip = document.createElement('div');
    tooltip.id = 'global-tooltip';
    document.body.appendChild(tooltip);

    const position = (target) => {
        const rect = target.getBoundingClientRect();
        tooltip.style.left = (rect.left + rect.width / 2) + 'px';
        tooltip.style.top = (rect.top - tooltip.offsetHeight - 8) + 'px';
    };

    document.addEventListener('mouseover', (e) => {
        const target = e.target.closest('[data-tips]');
        if (!target || !target.dataset.tips) {
            tooltip.classList.remove('show');
            return;
        }
        tooltip.textContent = target.dataset.tips;
        position(target);
        tooltip.classList.add('show');
    });

    document.addEventListener('mouseout', (e) => {
        if (e.target.closest('[data-tips]')) {
            tooltip.classList.remove('show');
        }
    });

    window.addEventListener('scroll', () => tooltip.classList.remove('show'), true);
})();

(async function () {
    const supabaseSources = [
        'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2/+esm',
        'https://unpkg.com/@supabase/supabase-js@2/dist/module/index.js',
        'https://cdn.skypack.dev/@supabase/supabase-js@2'
    ];

    for (const source of supabaseSources) {
        try {
            const { createClient } = await import(source);
            window.supabase = createClient(supabaseUrl, supabaseKey);
            break;
        } catch {
            continue;
        }
    }

  const app = createApp(App);

  app.mount('#app');
})()